import * as d3 from 'd3'
export default {
  methods: {
    init_ChartData() {

      //  if(this.getSelectItems) {
      //   this.getItems = JSON.parse(this.getSelectItems)
      //   if(this.getItems.current) this.current = this.getItems.current
      // }

      this.canvasChart = this.canvasForm
      .append('g')
      .attr('id', `CHART_CANVAS`)
      .attr('transform', `translate(${this.chart.x}, ${this.chart.y})`)

      // setting Chart Data
      this.chartData = this.rawData.filter(f=> f[this.config.refCode] == this.current.menu)

      // Setting Chart Timeline
      this.timeline.month = []
      this.timeline.year = []

      this.timeline.axis = d3.scaleBand()
      .domain(this.chartData.map(d => d.CDATE ))
      .range([0, this.chart.width])
      this.timeline.band = this.timeline.axis.bandwidth()

      // ##### init_TimelineValue.js #####
      this.gmx_BandScaleValues_Month(this.chartData) 

      this.chartData.forEach((d,i)=> {
        d.bxs = this.gmx_BarCoordinates(d.mx, [...this.chart.columns.filter(f=> f.type=='BAR').map(m => m.size)], this.chart.barGap)
      })


      // Setting Primary  
      let maxArray = []
      if(this.secondary.visible == 'Y') {
        this.chart.columns.filter(f=> f.type == 'LINE').forEach((s,i)=> {
          maxArray.push(d3.max(this.chartData, c => c[s.code]))
        })

        if(d3.max(maxArray) == 0) this.secondary.max = 5
        this.primary.max = this.gmx_maxBound5(d3.max(maxArray))

        this.primary.axis = d3.scaleLinear()
        .domain([0, this.primary.max])
        .range([this.chart.height, 0])
      }


      // Setting Secondary
      maxArray = []
      if(this.secondary.visible == 'Y') {
        this.chart.columns.filter(f=> f.type == 'BAR').forEach((s,i)=> {
          maxArray.push(d3.max(this.chartData, c => c[s.code]))
        })
        if(d3.max(maxArray) == 0) this.secondary.max = 5
        this.secondary.max = this.gmx_maxBound5(d3.max(maxArray))
        this.secondary.axis = d3.scaleLinear()
        .domain([0, this.secondary.max])
        .range([0, this.chart.height])
      }
    },
    

    
    draw_ChartAxis() {
      let axes = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.chart.x+.5}, ${this.chart.y+.5})`)

      this.gmx_Line(axes, 0, 0, 0, this.chart.height, '#757575', .5, 1)
      this.gmx_Line(axes, 0, this.chart.width, this.chart.height, this.chart.height, '#757575', .5, 1)
      this.gmx_Line(axes, this.chart.width, this.chart.width, 0, this.chart.height, '#757575', .5, 1)

      axes // Primary Title
      .append('text')
      .attr('transform', `translate(${- this.primary.padding}, ${this.chart.height/2}) rotate(-90)`)
      .attr('font-size', this.primary.tSize).attr('fill', this.primary.tColor)
      .attr('text-anchor', 'middle')
      .text(this.primary.title)

      axes // Secondary Title
      .append('text')
      .attr('transform', `translate(${this.chart.width + this.secondary.padding}, ${this.chart.height/2}) rotate(-90)`)
      .attr('font-size', this.secondary.tSize).attr('fill', this.secondary.tColor)
      .attr('text-anchor', 'middle')
      .text(this.secondary.title)
    },



    draw_Grid() {
      let tick = this.chart.height / 5

      let grids = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.chart.x}, ${this.chart.y})`)

      for(let i=0; i<6; i++) {
        this.gmx_Line(grids, 0, this.chart.width, tick * i, tick * i, '#bcbcbc', .5, .5)

        grids // Primary Axis
        .append('text')
        .attr('x', -2).attr('y', this.chart.height - (tick * i) + (this.grid.tSize/2)-1) 
        .attr('font-size', this.grid.tSize).attr('fill', this.grid.tColor).attr('text-anchor', 'end')
        .text(()=> {
          let value = (this.primary.max * (i*.2)).toFixed(this.primary.round)
          if(this.primary.unit.toLowerCase() == 'k') value = (value/1000)
          return value + this.primary.unit
        })

        grids // Secondary Axis
        .append('text')
        .attr('x', this.chart.width+2).attr('y', this.chart.height - (tick * i) + (this.grid.tSize/2)-1) 
        .attr('font-size', this.grid.tSize).attr('fill', this.grid.tColor)
        .text(()=> {
          let value = (this.secondary.max * (i*.2)).toFixed(this.secondary.round)
          if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000)
          return value + this.secondary.unit
        })
      }
    },

  }
}
           